

import {
  VERIFIED_USER_LISTING_REQUEST,
  VERIFIED_USER_LISTING_FAIL,
  VERIFIED_USER_LISTING_SUCCESS,
  VERIFIED_USER_LISTING_UPDATE_USER_STATUS,
} from "../../constants/actions";

const initialState = {
  loading: false,
  loginSucces: false,
  usersListing:[],
  totalUsers:0,
  error: false,
};





const userListingReducer = (state = initialState, action) => {

  switch (action.type) {
    case VERIFIED_USER_LISTING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case VERIFIED_USER_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        loginSucces: true,
        totalUsers:action.payload.total,
        usersListing: action.payload.user_info,
      };
      case VERIFIED_USER_LISTING_UPDATE_USER_STATUS:
      return {
        ...state,
        usersListing: state.usersListing.map((user) =>
          user.id === action.payload.userId ? { ...user, status: action.payload.status } : user
        ),
      };
   
    case VERIFIED_USER_LISTING_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };

    
    default:
      return state;
  }
};

export default userListingReducer;
